// @flow
export type ImageDimensionsInfo = {|
  bestPinsImages?: Array<{|
    height: number,
    url: string,
    width: number,
  |}>,
  height: number,
  url: string,
  width: number,
|};

/**
 * Dispatch action to set selected interests' images
 * @param {Array<ImageDimensionsInfo>} images The images to set
 */
export type SetNuxSelectedInterestImages = {
  type: 'SET_NUX_SELECTED_INTEREST_IMAGES',
  payload: {
    images: Array<ImageDimensionsInfo>,
  },
};

export default function setNuxSelectedInterestImages(
  images: Array<ImageDimensionsInfo>,
): SetNuxSelectedInterestImages {
  return {
    type: 'SET_NUX_SELECTED_INTEREST_IMAGES',
    payload: { images },
  };
}
